<!-- view header -->
<header class="w-100 d-flex view-header-container" [ngClass]="{
    'pt-3' : isExtraSmall || isSmallSize
}" *ngIf="buttonContainerMetadata || this.getDescription() || this.getTitle()">

    <!-- go back section -->
    <div class="go-back-container d-flex align-items-start" *ngIf="this.getLastViewCode()">
        <div class="go-back-button th-line d-flex justify-content-center align-items-center th-bg-white th-text-main"
             (click)="goBack()"> 
            <i class="fa fa-angle-left" aria-hidden="true"></i>
        </div>
    </div>

    <!-- title and description section -->
    <div class="information-container d-flex flex-column">
        <h1 class="bs-h1 th-text-main m-0 p-0">{{ getTitle() }}</h1>
        <span class="ly-sp-xs-top bs-paragraph th-text-gray-paragraphs" 
        [innerHTML]="getDescription()"></span>
    </div>    

    <!-- buttons section -->
    <div class="button-container ms-auto me-3 d-flex align-items-center">
        <ng-container #viewButtonContainer></ng-container>
    </div>

</header>

<!-- view content -->
<div #target [id]="getId()"></div>

<!-- dynamic messages from service -->
<ng-container #plusMessageContainer></ng-container>
<ng-container #plusDialogContainer></ng-container>